import React from "react";
import moment from "moment";
import { OHS_BASE_PATH } from "./ohsConstants";
import { BoxCardLink, BoxCardMeta, BoxCardTitle } from "./Ohs.styles";
import ConditionBadges from "./ConditionBadges";

/**
 * One box as a clickable card - title, who's assigned, when it was last checked, and its condition.
 * @param {Object} props
 * @param {Object} props.box Box row from the manager overview.
 * @param {boolean} [props.showCampus=false] Prefix the title with campus/building (for lists not grouped by campus).
 */
function BoxSummaryCard({ box, showCampus = false }) {
    const location = showCampus
        ? `${box.campus_name} — ${box.building_name}, ${box.area_location}`
        : `${box.building_name} — ${box.area_location}`;

    return (
        <BoxCardLink to={`${OHS_BASE_PATH}/boxes/open/${box.id}`}>
            <span>
                <BoxCardTitle>{location}</BoxCardTitle>
                <BoxCardMeta>
                    {box.box_code}
                    {" · "}Assigned: {box.assigned_name || "Unassigned"}
                    {" · "}Last checked: {box.last_checked_at ? moment(box.last_checked_at).format("D MMM YYYY") : "never"}
                </BoxCardMeta>
            </span>
            <ConditionBadges statuses={box.statuses || [box.last_check_condition]} />
        </BoxCardLink>
    );
}

export default BoxSummaryCard;
